export const CONSENT_COOKIE = 'donottrack';
export const CONSENT_COOKIE_EXPIRATION = 30;
